import {ApiRequest} from '@aofl/api-request';
let apiRequest = new ApiRequest();
export default apiRequest;



// WEBPACK FOOTER //
// ./api-request/index.js